import React, { useState } from 'react';
import { Button } from './Button';
import { Input } from './Input';
import { Select } from './Select';
interface FormData {
  homeValue: string;
  propertyInGTA: string;
  city: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
}
export function MultiStepForm() {
  const [formData, setFormData] = useState<FormData>({
    homeValue: '',
    propertyInGTA: 'yes',
    city: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: ''
  });
  const [errors, setErrors] = useState<Partial<FormData>>({});
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const validateForm = () => {
    const newErrors: Partial<FormData> = {};
    if (!formData.homeValue || parseFloat(formData.homeValue) <= 0) {
      newErrors.homeValue = 'Please enter a valid home value';
    }
    if (!formData.city.trim()) {
      newErrors.city = 'Please enter your city';
    }
    if (!formData.firstName.trim()) {
      newErrors.firstName = 'Please enter your first name';
    }
    if (!formData.lastName.trim()) {
      newErrors.lastName = 'Please enter your last name';
    }
    if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
    }
    if (!formData.phone.trim() || !/^\+?[\d\s\-()]+$/.test(formData.phone)) {
      newErrors.phone = 'Please enter a valid phone number';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    if (!agreedToTerms) {
      alert('Please agree to the Terms and Conditions');
      return;
    }
    console.log('Form submitted:', formData);
    alert('Thank you! Your assessment request has been submitted. We will contact you shortly.');
  };
  const updateFormData = (field: keyof FormData, value: string) => {
    setFormData({
      ...formData,
      [field]: value
    });
    if (errors[field]) {
      setErrors({
        ...errors,
        [field]: undefined
      });
    }
  };
  return <div className="bg-white rounded-2xl shadow-xl p-6 md:p-8 w-full" id="form" data-id="element-232">
      <div className="mb-6" data-id="element-233">
        <h2 className="text-3xl md:text-4xl font-serif text-gray-900 mb-2" data-id="element-234">
          Find Out How Much You Can Borrow
        </h2>
        <p className="text-gray-600" data-id="element-235">Get your free assessment in minutes</p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4" data-id="element-236">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-237">
          <Input label="Home Value" type="text" prefix="$" placeholder="500,000" value={formData.homeValue} onChange={value => updateFormData('homeValue', value)} error={errors.homeValue} required data-id="element-238" />

          <Select label="Property in GTA?" value={formData.propertyInGTA} onChange={value => updateFormData('propertyInGTA', value)} options={[{
          value: 'yes',
          label: 'Yes'
        }, {
          value: 'no',
          label: 'No'
        }]} required data-id="element-239" />
        </div>

        <Input label="City" type="text" placeholder="Toronto" value={formData.city} onChange={value => updateFormData('city', value)} error={errors.city} required data-id="element-240" />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-241">
          <Input label="First Name" type="text" placeholder="John" value={formData.firstName} onChange={value => updateFormData('firstName', value)} error={errors.firstName} required data-id="element-242" />

          <Input label="Last Name" type="text" placeholder="Smith" value={formData.lastName} onChange={value => updateFormData('lastName', value)} error={errors.lastName} required data-id="element-243" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-244">
          <Input label="Email" type="email" placeholder="john@email.com" value={formData.email} onChange={value => updateFormData('email', value)} error={errors.email} required data-id="element-245" />

          <Input label="Phone/Mobile" type="tel" placeholder="(647) 000-0000" value={formData.phone} onChange={value => updateFormData('phone', value)} error={errors.phone} required data-id="element-246" />
        </div>

        <div className="flex items-start pt-2" data-id="element-247">
          <input type="checkbox" id="terms" checked={agreedToTerms} onChange={e => setAgreedToTerms(e.target.checked)} className="mt-1 h-4 w-4 text-primary focus:ring-primary border-gray-300 rounded" data-id="element-248" />
          <label htmlFor="terms" className="ml-3 text-sm text-gray-600" data-id="element-249">
            By clicking "Submit" you agree that you are submitting an inquiry to
            EquityRich.ca, and you agree to our{' '}
            <a href="/terms" className="text-primary underline hover:text-primary-dark" data-id="element-250">
              Terms and Conditions
            </a>{' '}
            and{' '}
            <a href="/privacy" className="text-primary underline hover:text-primary-dark" data-id="element-251">
              Privacy Policy
            </a>
          </label>
        </div>

        <Button type="submit" variant="secondary" size="lg" className="w-full" icon data-id="element-252">
          Get My Free Assessment
        </Button>
      </form>
    </div>;
}